export const MACROS_INITIAL_VALUE = {
  fibers: 0,
  carbohydrates: 0,
  fats: 0,
  proteins: 0,
  calories: 0,
};

export type Macros = typeof MACROS_INITIAL_VALUE;
